function clientSelectDirective() {
	return {
		scope : {
			client : '=',
			disabled : '&',
			onClientChange : '&',
			filters : '<?'
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/clientSelectDirective.html';
		},
		controller : [ '$scope', '$window', 'alertService', 'clientService', function($scope, $window, alertService, clientService) {

			var init = true;
			
			$scope.availableClients = [];
			$scope.ctrlDisabled = false;
			$scope.onlyActives = false;

			if ($scope.onlyActivesModel)
				$scope.onlyActives = true;

			if ($scope.disabled())
				$scope.ctrlDisabled = true;

			$scope.searchClients = function(query) {
				var filter = {};

				if ($scope.filters)
					filter = $scope.filters;

				filter.name = query, filter.value = query

				console.log('consultando desde directiva de cliente');
				clientService.searchClients(filter).then(function(response) {
					$scope.availableClients = response.getData().results;
					//se hace solo la primera vez y es por si solo se conoce el id del cliente que se quiere seleccionar
					if ($scope.client && $scope.client.id && init) {
						init = false;
						var sel = $scope.availableClients.find(function(c) {
							return c.id == $scope.client.id;
						});
						if (sel) {
							$scope.client.selected = [];
							$scope.client.selected.push(sel);
						} else {
							clientService.getClientBasicInfo($scope.client.id).then(function(response) {
								$scope.client.selected = [];
								$scope.client.selected.push(response.getData());
							});
						}
						$scope.client.id =  undefined;
					}
				}, function(response) {
					// on error
				});
			};

			$scope.clientChanged = function(client) {
				if ($scope.onClientChange != undefined) {
					$scope.onClientChange({
						client : client
					});
				}
			};

		} ],
		link : function(scope, elem, attr) {
			scope.$watch("disabled()", function(newValue){
				scope.ctrlDisabled = newValue;
			});
		}
	};
};

module.directive('clientSelect', [ clientSelectDirective ]);